import { Badge, EmptyState, Skeleton } from '@personachat/ui';
import { FileText } from 'lucide-react';
import { Link, Outlet } from 'react-router-dom';

import { ErreurChargement } from '../../components/bits';
import { formatDate, formatNombre } from '../../lib/format';
import { PageHeader } from '../../pages/PageHeader';

import { useCatalogue, useEcritureContenus } from './catalogue';
import { Avatar } from './CoachsPage';

/** /prompts : la liste ; /prompts/:id : l'éditeur plein écran. */
export function PromptsLayout() {
  return <Outlet />;
}

/**
 * Prompts des coachs (cahier des charges §7.7) : un prompt par coach, chaque
 * publication crée une version qu'on peut comparer, tester et restaurer.
 */
export function PromptsListe() {
  const catalogue = useCatalogue();
  const ecriture = useEcritureContenus();

  return (
    <>
      <PageHeader
        title="Prompts des coachs"
        lead={
          ecriture
            ? 'Ouvrez un prompt pour le modifier : testez le brouillon dans une conversation d’essai, comparez-le à la version en service, puis publiez.'
            : 'Consultation : seul un super admin publie un prompt. Vous pouvez lire les versions et les comparer.'
        }
      />
      {catalogue.isError ? (
        <ErreurChargement erreur={catalogue.error} onReessayer={() => void catalogue.refetch()} />
      ) : !catalogue.data ? (
        <Skeleton height={240} />
      ) : catalogue.data.every((m) => m.coaches.length === 0) ? (
        <EmptyState icon={<FileText size={26} aria-hidden="true" />} title="Aucun coach" />
      ) : (
        <div className="stack">
          {catalogue.data
            .filter((m) => m.coaches.length > 0)
            .map((m) => (
              <section key={m.id} className="catalogue__module">
                <div className="catalogue__entete">
                  <div className="catalogue__titre">
                    <strong>{m.name}</strong>
                  </div>
                </div>
                <ul className="catalogue__coachs">
                  {m.coaches.map((c) => (
                    <li key={c.id} className="catalogue__coach">
                      <Avatar nom={c.name} url={c.avatar} />
                      <Link className="catalogue__coach-lien" to={`/prompts/${c.id}`}>
                        <span className="cell-main">{c.name}</span>
                        <span className="cell-sub">
                          {formatNombre(c.promptLength)} caractères · {formatNombre(c.promptVersions)} version{c.promptVersions > 1 ? 's' : ''}
                          {c.promptUpdatedAt && ` · dernière le ${formatDate(c.promptUpdatedAt)}`}
                        </span>
                      </Link>
                      {!c.isActive && <Badge>Inactif</Badge>}
                    </li>
                  ))}
                </ul>
              </section>
            ))}
        </div>
      )}
    </>
  );
}
